/**
 * This function manipulate the array adding numbers before and/or after the currentPage based on siblings definition.
 * If siblings = 2, it means to add two number before and/or after the currentPage.
 * es.
 * pagesArray = [1,6,10]
 * siblings = 2
 * currentPage = 6
 * pagesArray = [1,4,5,6,7,8,10]
 */
const addSiblings = (pagesArray, currentPage, totalPages, siblings) => {
    for (let i = 1; i <= siblings; i += 1) {
        if (currentPage === 1) {
            pagesArray.splice(i, 0, currentPage + i);
        }
        if (currentPage !== 1 && currentPage - i > 1) {
            pagesArray.splice(1, 0, currentPage - i);
            if (currentPage !== totalPages) {
                if (currentPage + i < totalPages) {
                    pagesArray.splice(pagesArray.indexOf(currentPage) + i, 0, currentPage + i);
                }
            }
        }
    }
    return pagesArray;
};
export const createPaginationArray = (pages, currentPage, siblings) => {
    const paginationArray = [1, pages];
    if (!paginationArray.includes(currentPage)) {
        paginationArray.splice(1, 0, currentPage);
    }
    if (siblings) {
        addSiblings(paginationArray, currentPage, pages, siblings);
    }
    paginationArray.forEach((el, index) => {
        if (el !== "...") {
            if (paginationArray[index + 1] !== el + 1 && index + 1 < pages) {
                paginationArray.splice(index + 1, 0, "...");
            }
        }
    });
    return paginationArray;
};
